"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReportEmbedInfo = getReportEmbedInfo;
const axios_1 = __importDefault(require("axios"));
const configService_1 = require("./configService");
const ServiceError_1 = require("./ServiceError");
const API_URL = (0, configService_1.getAPIUrl)();
const API_REPORT_EMBED_INFO = `${API_URL}/pbi/getReportEmbedInfo`;
function getReportEmbedInfo(reportId, workspaceId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const requestBody = {
                reportId,
                workspaceId
            };
            const response = yield axios_1.default.post(API_REPORT_EMBED_INFO, requestBody);
            return response.data;
        }
        catch (error) {
            throw new ServiceError_1.ServiceError(error);
        }
    });
}
